module.exports = __webpack_public_path__ + "img/main2.b8d99524.png";